export default "__VITE_ASSET__c53e9f4c__"